import { useMutation } from '@tanstack/react-query';

import { PostContactInfoPayload, PostContactInfoResponse } from '@/api/userAccount/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';

export const postContactInfo = (payload: PostContactInfoPayload): Promise<PostContactInfoResponse> => {
    return axios.post('/profile/change-contact-information', payload);
};

type UsePostContactInfoOptions = {
    config?: MutationConfig<typeof postContactInfo>;
    data?: PostContactInfoPayload;
};

export const usePostContactInfo = ({ config }: UsePostContactInfoOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: postContactInfo,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['user-account'] }),
    });
};
